import React from "react";
import { MdBolt } from "react-icons/md";

import { SetupCard } from "../../../../../components/newUI/setup-card";
import {
  AutomationItem,
  AutomationLookupOptions,
} from "../../../../work/pages/automation/automation.constants";
import { AutomationCard } from "../../../../work/pages/automation/AutomationCard";

type AddWorkAutomationSectionProps = {
  automation: AutomationItem | null;
  options: AutomationLookupOptions;
  isDeleting?: boolean;
  /** A repeat schedule is set: the automation is copied to each next item. */
  repeats?: boolean;
  onAddAutomation: () => void;
  onDeleteAutomation: (automation: AutomationItem) => void;
};

export const AddWorkAutomationSection: React.FC<
  AddWorkAutomationSectionProps
> = ({
  automation,
  options,
  isDeleting = false,
  repeats = false,
  onAddAutomation,
  onDeleteAutomation,
}) => {
  return (
    <div className={"border-t border-[#ECEFF3] pt-[18px]"}>
      {automation ? (
        <AutomationCard
          automation={automation}
          workName={"work item"}
          options={options}
          isDeleting={isDeleting}
          hideWorkItemTitle
          sourceText={
            repeats
              ? "Will be added when this work is created and copied to each repeat"
              : "Will be added when this work is created"
          }
          onDelete={onDeleteAutomation}
        />
      ) : (
        <SetupCard
          icon={<MdBolt className={"h-[18px] w-[18px]"} />}
          title={"Add an automation"}
          description={
            "Trigger an action automatically based on this work's status."
          }
          onClick={onAddAutomation}
        />
      )}
    </div>
  );
};
